/*
 * @Author: LSG
 * @Date: 2021-08-30 17:46:43
 * @LastEditors: DQL
 * @LastEditTime: 2022-05-26 10:56:09
 * @Description: file content
 */
/* =============================================
   业务功能路由配置文件引入start
  *
  *
*/

// 请销假管理
import qxjglRoutes from '@/features/attendance/qxjgl/qxjgl.routes.js';

// 加班管理
import jbglRoutes from '@/features/attendance/jbgl/jbgl.routes.js';

// 年假管理
import njglRoutes from '@/features/attendance/njgl/njgl.routes.js';

// 假期配置
import jqpzRoutes from '@/features/attendance/jqpz/jqpz.routes.js';

// 假期统计
import vacationListRoutes from '@/features/attendance/vacationList/vacationList.routes.js';

/* 业务功能路由配置文件引入 End */

/* =============================================
   业务功能路由配置写入 Start
  *
  *
*/
const FEATURES_ROUTES = [qxjglRoutes, jbglRoutes, njglRoutes, jqpzRoutes, vacationListRoutes];

/* 业务功能路由配置写入 End */

// 路由配置=============================================
const attendanceRoutes = {
  path: 'attendance',
  name: 'attendance',
  component: { template: '<router-view></router-view>' },
  children: [...FEATURES_ROUTES]
};

export default attendanceRoutes;
